export const MEASUREMENT_SYSTEMS = {
  usc: 'usc',
  metric: 'metric',
};

export const DISTANCE_UNITS = {
  [MEASUREMENT_SYSTEMS.metric]: {m: 'meters', km: 'kilometers'},
  [MEASUREMENT_SYSTEMS.usc]: {
    ft: 'feet',
    mi: 'miles',
    nmi: 'nauticalmiles',
  },
};
export const AREA_UNITS = {
  [MEASUREMENT_SYSTEMS.metric]: {
    m2: 'square-meters',
    km2: 'square-kilometers',
    ha: 'hectares',
  },
  [MEASUREMENT_SYSTEMS.usc]: {
    ft2: 'square-feet',
    mi2: 'square-miles',
    nmi2: 'square-nauticalmiles',
    ac: 'acres',
  },
};

export const UNIT_SYMBOLS = {
  [DISTANCE_UNITS.metric.m]: 'm',
  [DISTANCE_UNITS.metric.km]: 'km',
  [DISTANCE_UNITS.usc.ft]: 'ft',
  [DISTANCE_UNITS.usc.mi]: 'mi',
  [DISTANCE_UNITS.usc.nmi]: 'nmi',
  [AREA_UNITS.metric.m2]: 'm²',
  [AREA_UNITS.metric.km2]: 'km²',
  [AREA_UNITS.metric.ha]: 'ha',
  [AREA_UNITS.usc.ft2]: 'ft²',
  [AREA_UNITS.usc.mi2]: 'mi²',
  [AREA_UNITS.usc.nmi2]: 'nmi²',
  [AREA_UNITS.usc.ac]: 'ac',
};
